import {
  memo,
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";

// Per-question timer component
// - durationSeconds: time limit for the current question
// - questionKey: value that changes when question changes (e.g. index or id)
// - onTimeUp: callback fired once when timer reaches 0
// - startPaused: when true, timer does not count down until parent calls start()
// - onTick: optional callback fired every second with remaining seconds
const Timer = memo(
  forwardRef(({ durationSeconds = 0, questionKey, onTimeUp, startPaused = false, onTick }, ref) => {
    const [timeRemaining, setTimeRemaining] = useState(durationSeconds);
    const [isPaused, setIsPaused] = useState(startPaused);

    // Expose start, pause and resume to parent (start = begin countdown after TTS ends)
    useImperativeHandle(ref, () => ({
      start: () => {
        setIsPaused(false);
      },
      pause: () => {
        setIsPaused(true);
      },
      resume: () => {
        setIsPaused(false);
      },
    }));

    // Reset timer whenever the question or its duration changes
    useEffect(() => {
      setTimeRemaining(durationSeconds);
      setIsPaused(startPaused);
    }, [durationSeconds, questionKey, startPaused, onTick]);

    // Notify parent on every tick (outside render/state updater)
    useEffect(() => {
      if (typeof onTick === "function") {
        onTick(timeRemaining || 0);
      }
    }, [timeRemaining, onTick]);

    // Tick every second while not paused
    useEffect(() => {
      if (isPaused || !durationSeconds) return;

      let timer = setInterval(() => {
        setTimeRemaining((prev) => {
          const next = prev <= 1 ? 0 : prev - 1;
          if (next === 0) {
            clearInterval(timer);
          }
          return next;
        });
      }, 1000);

      return () => {
        if (timer) clearInterval(timer);
      };
    }, [isPaused, durationSeconds, onTick]);

    // Notify parent exactly once when time is up
    useEffect(() => {
      if (!isPaused && durationSeconds > 0 && timeRemaining === 0 && onTimeUp) {
        onTimeUp();
      }
    }, [timeRemaining, isPaused, durationSeconds, onTimeUp]);

    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    const percentage =
      durationSeconds > 0 ? (timeRemaining / durationSeconds) * 100 : 0;

    return (
      <></>
      // <Paper
      //   elevation={0}
      //   sx={{
      //     p: 3,
      //     bgcolor: "#1e293b",
      //     border: "1px solid rgba(255, 255, 255, 0.1)",
      //     borderRadius: 2,
      //     opacity: isPaused ? 0.6 : 1,
      //     transition: "opacity 0.3s ease",
      //   }}
      // >
      //   <Typography
      //     variant="body2"
      //     color="rgba(255, 255, 255, 0.6)"
      //     gutterBottom
      //   >
      //     Time Remaining 
      //   </Typography>
      //   <Typography variant="h3" fontWeight="bold" color="white" mb={2}>
      //     {minutes}:{seconds.toString().padStart(2, "0")}
      //   </Typography>
      //   <LinearProgress
      //     variant="determinate"
      //     value={percentage}
      //     sx={{
      //       height: 8,
      //       borderRadius: 1,
      //       bgcolor: "rgba(255, 255, 255, 0.1)",
      //       "& .MuiLinearProgress-bar": {
      //         bgcolor: isPaused ? "rgba(249, 115, 22, 0.6)" : "primary.main",
      //         borderRadius: 1,
      //       },
      //     }}
      //   />
      // </Paper>
    );
  }),
);

Timer.displayName = "Timer";

export default Timer;
